import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, Star } from 'lucide-react';
import { useCart } from '../context/CartContext';

export default function ProductCard({ product }) {
  const { addToCart } = useCart();
  const [hovered, setHovered] = useState(false);
  const [adding, setAdding] = useState(false);

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setAdding(true);
    addToCart(product);
    setTimeout(() => setAdding(false), 1200);
  };

  const discount = Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100);

  return (
    <Link
      to={`/product/${product.id}`}
      className="group block"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Image container */}
      <div className="relative overflow-hidden bg-[#fdf8f6] aspect-[3/4]">
        <img
          src={product.image}
          alt={product.name}
          className={`w-full h-full object-cover transition-transform duration-700 ${hovered ? 'scale-105' : 'scale-100'}`}
          loading="lazy"
        />

        {/* Badge */}
        {product.badge && (
          <div className={`absolute top-3 left-3 px-2.5 py-1 text-[10px] tracking-widest uppercase font-medium ${
            product.badge === 'Bestseller' ? 'bg-black text-white' :
            product.badge === 'New' ? 'bg-[#f5e6e0] text-black' :
            'bg-[#cc7c66] text-white'
          }`}>
            {product.badge}
          </div>
        )}

        {/* Discount */}
        {discount > 0 && (
          <div className="absolute top-3 right-3 bg-white/90 text-black text-[10px] font-medium px-2 py-1 rounded-sm">
            {discount}% off
          </div>
        )}

        {/* Add to cart overlay */}
        <button
          onClick={handleAdd}
          className={`absolute bottom-0 left-0 right-0 bg-black text-white py-3 text-xs tracking-[0.2em] uppercase font-medium transition-all duration-300 flex items-center justify-center gap-2 ${
            hovered ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
          }`}
        >
          <ShoppingBag size={14} />
          {adding ? 'Added!' : 'Add to Bag'}
        </button>
      </div>

      {/* Info */}
      <div className="mt-3 px-1">
        <p className="text-xs text-gray-400 tracking-widest uppercase mb-1">{product.category}</p>
        <h3 className="font-display text-base font-normal leading-snug group-hover:text-gray-600 transition-colors">
          {product.name}
        </h3>
        <div className="flex items-center gap-1.5 mt-1.5">
          <div className="flex items-center gap-0.5">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                size={10}
                className={i < Math.floor(product.rating) ? 'fill-black text-black' : 'fill-gray-200 text-gray-200'}
              />
            ))}
          </div>
          <span className="text-xs text-gray-400">({product.reviews})</span>
        </div>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="font-medium text-sm">₹{product.price.toLocaleString()}</span>
          <span className="text-xs text-gray-400 line-through">₹{product.originalPrice.toLocaleString()}</span>
        </div>
      </div>
    </Link>
  );
}
